import { Menu as AntdMenu } from "antd";
import { CMP_PREFIX } from "@/base/constant";
import type { GetProps } from "antd";

export type MenuProps = Partial<GetProps<typeof AntdMenu>>;

export const menuPrefixCls = `${CMP_PREFIX}-menu`;

export const Menu = ({ ...props }: MenuProps) => {
  return <AntdMenu {...props} />;
};
